export default "<p>audits works!</p>\n"